import { t } from "@/i18n-js/instance";
import { Row } from "@circle-react-uikit/SkeletonLoader/components";
import { Typography } from "@circle-react-uikit/Typography";
import { I18N_LOCALE_ROOT } from "./constants";

interface PlanTrialCardProps {
  className?: string;
  isPlanLoading?: boolean;
  plan?: {
    display_base_monthly_amount?: string;
    display_name?: string;
  };
}

export const PlanTrialCard = ({
  plan,
  isPlanLoading,
  className = "",
}: PlanTrialCardProps) => {
  const isLoading = isPlanLoading || !plan?.display_base_monthly_amount;
  const displayName = plan?.display_name;

  const trialPeriodText = isLoading ? (
    <Row md long />
  ) : (
    t(`${I18N_LOCALE_ROOT}.plan_card.trial_period_dynamic`, {
      price: plan.display_base_monthly_amount,
    })
  );

  return (
    <div
      className={`bg-primary border-primary rounded-xl border p-4 ${className}`}
    >
      <div className="mb-1 flex items-center justify-between">
        <div className="text-white">
          <Typography.LabelLg weight="semibold">
            {isPlanLoading || !displayName ? <Row md long /> : displayName}
          </Typography.LabelLg>
        </div>
        <div className="flex flex-row items-center gap-1 align-middle">
          <div className="text-white">
            <Typography.LabelMd weight="bold">
              {isPlanLoading ? (
                <Row md short />
              ) : (
                t(`${I18N_LOCALE_ROOT}.plan_card.price`)
              )}
            </Typography.LabelMd>
          </div>
        </div>
      </div>
      <div className="text-white/70">
        <Typography.LabelXs>{trialPeriodText}</Typography.LabelXs>
      </div>
    </div>
  );
};
